import React, { useState } from "react";
import PlanForm from "./AddPlanForm";
import {
  defaultPlanColorCode,
  generateUUID,
  isNullOrUndefined,
  planColorCodes,
} from "../../utils";
import { Dialog, Drawer } from "@mui/material";
import PlanHolderPlans from "./PlanHolderPlans";
import PlanHolderHeader from "./PlanHolderHeader";
import { format } from "date-fns";
import useWindowSize from "../../Hooks/useWindowSize";
import { TertiaryButton } from "./ScheduleComponents/CoursesSchedule";
import { useSearchParams } from "react-router-dom";

function TravelPlanHolder({ offering, selectedDateIndex, handleSetOffering }) {
  const { isMobileView, windowSize } = useWindowSize();
  const [plan, setPlan] = useState(undefined);
  const [isAddPlan, setIsAddPlan] = useState(false);
  const [searchParams] = useSearchParams();

  const [addTicketsToAllSlots, setAddTicketsToAllSlots] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleAddPlanToAllSlots = (plans) => {
    setAddTicketsToAllSlots(true);
    const new_dates = offering.scheduleDetails.map((date) => {
      const newDateObj = JSON.parse(
        JSON.stringify({
          ...date,
          timeSlots: date.timeSlots.map((timeslot) => ({
            ...timeslot,
            tickets: plans.map((newTicket) => ({
              ...newTicket,
              id: generateUUID(), // or use a more robust method for generating IDs
            })),
          })),
        })
      );
      return newDateObj;
    });
    handleSetOffering("scheduleDetails", new_dates);
  };

  const handleCheckIsPlanInTimeSlotPresent = (
    selectedDateIndex,
    planName,
    updateIndex
  ) => {
    const plansInTimeSlot = offering.scheduleDetails[selectedDateIndex].tickets;
    for (let i = 0; i < plansInTimeSlot.length; i++) {
      if (i === updateIndex) continue;
      if (
        plansInTimeSlot[i].ticketName.toLowerCase() === planName.toLowerCase()
      ) {
        return true;
      }
    }
    return false;
  };

  const handleUpdatePlans = (action, updateIndex, newEventPlan) => {
    if (newEventPlan.addTicketsToAllSlots) {
      handleAddPlanToAllSlots(newEventPlan);
      return;
    }
    const tickets = [...offering.scheduleDetails[selectedDateIndex].tickets];

    if (
      handleCheckIsPlanInTimeSlotPresent(
        selectedDateIndex,
        newEventPlan.ticketName,
        updateIndex
      )
    ) {
      return { error: "Cannot have plans with same name" };
    }
    if (action === "addnew") {
      let colorCode;
      if (isNullOrUndefined(planColorCodes[tickets.length])) {
        colorCode = defaultPlanColorCode;
      } else {
        colorCode = planColorCodes[tickets.length];
      }
      newEventPlan = { ...newEventPlan, planColorCodes: colorCode };
      handleSetOffering(
        `scheduleDetails.${selectedDateIndex}.tickets.push`,
        newEventPlan
      );
    } else if (action === "update") {
      handleSetOffering(
        `scheduleDetails.${selectedDateIndex}.tickets.${updateIndex}`,
        newEventPlan
      );
    } else {
      handleSetOffering(
        `scheduleDetails.${selectedDateIndex}.tickets.delete.${updateIndex}`,
        newEventPlan
      );
    }
    return { error: null };
  };

  const getPlanIndex = (plan) => {
    return offering.scheduleDetails[selectedDateIndex].tickets.indexOf(plan);
  };

  return (
    <>
      <PlanHolderHeader
        headerText={
          <>
            <b>Tickets</b> ( For{" "}
            {format(
              new Date(offering.scheduleDetails[selectedDateIndex].date),
              "MMM dd"
            )}
            )
          </>
        }
      />
      <PlanHolderPlans
        handleUpdatePlans={handleUpdatePlans}
        setPlan={(plan) => {
          setIsDialogOpen(true);
          setPlan(plan);
        }}
        tickets={offering.scheduleDetails[selectedDateIndex]?.tickets}
      />
      <div>
        <TertiaryButton
          buttonName={"Add New Plan"}
          onClick={() => {
            setIsAddPlan(true);
            setIsDialogOpen(true);
          }}
        />
      </div>
      {isMobileView() ? (
        <Drawer
          PaperProps={{
            sx: {
              height: windowSize.screenHeight * 0.8 + "px",
              borderRadius: "12px",
            },
          }}
          onClose={() => {
            setIsDialogOpen(false);
            setPlan(null);
          }}
          open={isDialogOpen}
          anchor="bottom"
        >
          <PlanForm
            plan={plan}
            offering={offering}
            isAddPlan={isAddPlan}
            pageType={searchParams.get("pageType")}
            index={getPlanIndex(plan)}
            updatePlans={handleUpdatePlans}
            closeDialog={() => {
              setIsAddPlan(false);
              setIsDialogOpen(false);
              // setPlan(null);
            }}
          />
        </Drawer>
      ) : (
        <Dialog
          PaperProps={{
            sx: {
              width: "45vw",
              height: "80vh",
              padding: "20px",
              borderRadius: "32px",
            },
          }}
          onClose={() => {
            setIsDialogOpen(false);
            setPlan(null);
          }}
          fullWidth
          open={isDialogOpen}
        >
          <PlanForm
            plan={plan}
            offering={offering}
            isAddPlan={isAddPlan}
            pageType={searchParams.get("pageType")}
            index={getPlanIndex(plan)}
            updatePlans={handleUpdatePlans}
            closeDialog={() => {
              setIsAddPlan(false);
              setIsDialogOpen(false);
              // setPlan(null);
            }}
          />
        </Dialog>
      )}
    </>
  );
}

export default TravelPlanHolder;
